<template>
  <div v-if="field_visible">
    <o-section :title="field_label">
      <transition-group name="slide-fade">
        <o-section
          title=""
          v-for="(entry, entry_idx) in all_items"
          :key="getKey(entry)"
          @close="close(entry_idx)"
          style="border-bottom: 0.1px solid lightgray; padding: 20px"
        >
          <f-widget-list
            :item="_current_values[entry_idx]"
            @change="changeRow(entry_idx, $event)"
            @error="handleError"
            :fields="field.fields"
            :design="design"
            :disabled="is_disabled"
            :selector="selector"
            :form-state="formState"
            :form-context="nestedFormContext"
            @fields-change="fieldsChanged"
          ></f-widget-list>
          <div class="card-actions" v-if="!is_disabled">
            <!-- TODO Find a better class -->
            <o-list-actions
              :list="_current_values"
              :index="entry_idx"
              :disable-delete="atMin"
            />
          </div>
        </o-section>
      </transition-group>
      <div class="row" v-if="!is_disabled">
        <div class="col-sm-2 self-start">
          <b-button :disabled="atMax" @click="addEntry">{{
            field.add_text || "Add Entry"
          }}</b-button>
        </div>
      </div>
    </o-section>
  </div>
</template>

<script>
import OListActions from "../../../vue-ocom/components/table/OListActions.vue";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";
import FWidgetList from "../FWidgetList.vue";
import MultipleContainerMixin from "../MultipleContainerMixin.js";
import { generateGUID } from "../../utils";

export default {
  name: "RepeatWidget",
  components: { FWidgetList, OSection, OListActions },
  mixins: [MultipleContainerMixin],
  methods: {
    getKey(entry) {
      if (!entry.__uuid) {
        entry.__uuid = generateGUID();
      }

      return entry.__uuid;
    },
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style scoped></style>
